import { useBuildOrgTree } from '@/services/org/useBuildOrgTree';
import { useMemo } from 'react';
import { ProcessedOrgTree } from './TenantRestrictionTree';

export const useProcessOrgTreeForTenantRestrictions = (hiddenFromTenantIds?: string[]) => {
  const [orgTree] = useBuildOrgTree();

  return useMemo(() => {
    return orgTree
      .filter(msp => msp.customers.length > 0)
      .map(msp => {
        return {
          ...msp,
          customers: msp.customers.map(customer => {
            return {
              ...customer,
              checked: Boolean(hiddenFromTenantIds?.includes(customer.customerId))
            };
          }),
          checked: Boolean(hiddenFromTenantIds?.includes(msp.mspId))
        };
      }) as ProcessedOrgTree[];
  }, [orgTree, hiddenFromTenantIds]);
};
